import * as React from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useTranslation } from "react-i18next"
import { Tooltip } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import TablePagination from "@mui/material/TablePagination";
import { t } from 'i18next'
import dayjs from 'dayjs'
import { useState } from 'react'
import { visuallyHidden } from '@mui/utils';
import { getComparator, stableSort } from '../../helpers/DailyBoardTableHelpers'


function Row(props) {
    const { row, user } = props;
    const [open, setOpen] = React.useState(false)

    return (
        <React.Fragment >
            <TableRow sx={{ '& > *': { borderBottom: 'unset !important' } }}>
                <TableCell sx={{ padding: '8px 16px', position: 'relative', fontWeight: '500' }}>
                    {row.po_number}
                </TableCell>
                <TableCell sx={{ padding: '8px 16px', fontStyle: 'italic' }}>{row.vendor_name}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>{<ShowDate date={row.requested_collection_date} />}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>
                    {
                        <Status slug={row.po_status_slug} />
                    }
                </TableCell>
                <TableCell sx={{ padding: '8px 5px' }}>
                    {
                        <PurchaseOrderActions
                            order={row}
                            user={user}
                        />
                    }
                </TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell style={{ padding: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: '20%' }}>{t('item_no')}</TableCell>
                                        <TableCell sx={{ width: '50%' }}>{t('description')}</TableCell>
                                        <TableCell sx={{ width: '20%' }}>{t('qty_expected')}</TableCell>
                                        <TableCell sx={{ width: '10%' }}>{t('qty_received')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.purchase_order_items.map((historyRow) => (
                                        <TableRow key={historyRow.id}>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.item_no}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.description}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.qty_ordered}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow?.qty_received || 0}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>

        </React.Fragment>
    );
}

const SortableTableHeaderRow = (props) => {
    const { order, orderBy, onRequestSort } = props
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                {/* Purchase Order No. cell */}
                <TableCell
                    sortDirection={orderBy === 'po_number' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'po_number'}
                        direction={orderBy === 'po_number' ? order : 'asc'}
                        onClick={createSortHandler('po_number')}>
                        {t('purchase_order_no')}
                        {orderBy === 'po_number' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                {/* Vendor Name cell */}
                <TableCell
                    sortDirection={orderBy === 'vendor_name' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'vendor_name'}
                        direction={orderBy === 'vendor_name' ? order : 'asc'}
                        onClick={createSortHandler('vendor_name')}>
                        {t('vendor')}
                        {orderBy === 'vendor_name' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                {/* Requested Collection Date cell */}
                <TableCell
                    sortDirection={orderBy === 'requested_collection_date' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'requested_collection_date'}
                        direction={orderBy === 'requested_collection_date' ? order : 'asc'}
                        onClick={createSortHandler('requested_collection_date')}>
                        {t('requested_collection_date')}
                        {orderBy === 'requested_collection_date' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                {/* Status cell */}
                <TableCell
                    sortDirection={orderBy === 'po_status' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'po_status'}
                        direction={orderBy === 'po_status' ? order : 'asc'}
                        onClick={createSortHandler('po_status')}>
                        {t('status')}
                        {orderBy === 'po_status' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                <TableCell sx={{ color: '#88909C !important', fontWeight: '400' }}>{t('actions')}</TableCell>
                <TableCell />
            </TableRow>
        </TableHead>
    )
}

export default function CollapsibleTable({ items, user }) {

    const { t } = useTranslation()

    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(10);
    const [orderBy, setOrderBy] = useState('created_at')
    const [order, setOrder] = useState('desc')

    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const handleRequestSort = (event, property) => {
        if (order === 'desc' && orderBy === property) {
            setOrderBy('created_at')
        } else {
            const isAsc = orderBy === property && order === 'asc'
            setOrder(isAsc ? 'desc' : 'asc')
            setOrderBy(property)
        }
    }

    const visibleCollections = React.useMemo(
        () =>
            stableSort(items, getComparator(order, orderBy)).slice(
                pg * rpg,
                pg * rpg + rpg,
            ),
        [items, order, orderBy, pg, rpg],
    )

    return (
        <>
            <div style={{ width: '100%', mb: 2, border: 'none' }}>
                <TableContainer>
                    <Table aria-label="collapsible table" stickyHeader>
                        <colgroup>
                            <col width="15%" />
                            <col width="15%" />
                            <col width="25%" />
                            <col width="25%" />
                            <col width="10%" />
                            <col />
                        </colgroup>
                        <SortableTableHeaderRow
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                            {items.length <= 0 ? <TableRow><TableCell colSpan={6} sx={{ textAlign: 'center' }}>{t('no_data')}</TableCell></TableRow> : null}
                            {visibleCollections?.map((row) => (
                                <Row key={row.id} row={row} user={user} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    className='table-pagination'
                    labelRowsPerPage={t('rowsPerPage')}
                    rowsPerPageOptions={[10, 15]}
                    component="div"
                    count={items.length}
                    rowsPerPage={rpg}
                    page={pg}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </>
    );
}

const Status = ({ slug }) => {
    const { t } = useTranslation()

    const renderStatusComponent = () => {
        const immutableClasses = 'w-full rounded-md p-1 text-center font-[500] capitalize'
        let className = ''

        switch(slug) {
            case "open":
            case "reopened":
                className = 'bg-[#D2ECFE] text-[#0073C1]'
                break
            case "released":
                className = 'bg-[#FFD48F] text-[#9D6000]'
                break
            case "assigned_to_driver":
                className = 'bg-[#FFE4B9] text-[#804E00]'
                break
            case "in_transit":
                className = 'bg-[#D5EDFB] text-[#008A93]'
                break
            case "on_site":
                className = 'bg-[#BEFFD6] text-[#017C40]'
                break
            case "assigned_to_fork":
                className = 'bg-[#FFF0B6] text-[#8A5001]'
                break
            case "unloading":
                className = 'bg-[#FDFF8D] text-[#BB7B00]'
                break
            case "unloaded":
                className = 'bg-[#FFED8D] text-[#B16103]'
                break
            case "completed":
            case "completed_by_driver":
                className = 'bg-[#BEFFD6] text-[#017C40]'
                break
            case "invoiced":
                className = 'bg-[#E8E8E8] text-[#515151]'
                break
            case "rejected":
                className = 'bg-[#FFD1D1] text-[#B81100]'
                break
            default:
                className = 'bg-[#686868] text-[#d1c6c6]'
        }

        className = className.concat(' ', immutableClasses)

        return (
            <div className={className}>{t(slug)}</div>
        )
    }

    return renderStatusComponent()
}

const PurchaseOrderActions = ({ order, user }) => {

    const {
        id,
        broker_transaction_id,
        broker_transaction_logistics_type,
        transaction_uploaded_bol,
        uploaded_bol,
        access_code,
        uploaded_driver_bol,
        po_status_id,
        po_status_slug
    } = order

    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()

    const getPodUrl = (_id) => {
        if(uploaded_driver_bol)
            return uploaded_driver_bol?.document_url;

        if(uploaded_bol)
            return uploaded_bol?.document_url;

        if(transaction_uploaded_bol)
            return transaction_uploaded_bol?.document_url

        const urlStem = `broker-transactions/${_id}`
        const urlRoot = `${process.env.REACT_APP_BACKEND_URL}/api`
        const urlLeaves = `proof-of-delivery?stream=view&party=supplier&CLIENT_ID=${localStorage.getItem('client_id')}&CLIENT_TIMEZONE=${encodeURIComponent(localStorage.getItem('client_timezone'))}`

        return `${urlRoot}/${urlStem}/${urlLeaves}`
    }

    return (
        <>
            <div className='flex gap-1'>
                <Tooltip disableInteractive title="BOL/POD" placement='bottom'>
                    <div style={{ color: 'rgba(0,0,0,.54)' }}>
                        <a href={getPodUrl(broker_transaction_id)} target="_blank"><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-print"></i></span></a>
                    </div>
                </Tooltip>

                <Tooltip disableInteractive title={t('open')} placement='bottom'>
                    <div style={{ color: 'rgba(0,0,0,.54)' }}>
                        <button onClick={() => navigate(
                            `${broker_transaction_id}`,
                            {
                                state: {
                                    prevPathname: location.pathname
                                }
                            }
                        )}><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-eye"></i></span></button>
                    </div>
                </Tooltip>

                {
                    (
                        ['released', 'assigned_to_driver', 'in_transit'].includes(po_status_slug)
                        && access_code
                        && localStorage.getItem('impersonate') === null
                    ) ? (
                        <Tooltip disableInteractive title={t('view_as_driver')} placement='bottom'>
                            <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                <button
                                    onClick={() => {
                                        const url = broker_transaction_logistics_type == 'tpl'
                                            ? `/3pl?code=${access_code}`
                                            : `/broker-sales?code=${access_code}`

                                        navigate(url)
                                    }}
                                >
                                    <span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-truck"></i></span>
                                </button>
                            </div>
                        </Tooltip>
                    ) : null
                }
            </div>
        </>
    )
}

export const ShowDate = ({ date }) => {

    const date1 = new Date(dayjs(date).format("YYYY-MM-DD"))
    const date2 = new Date(dayjs().format("YYYY-MM-DD"))

    return (
        <div>
            {
                date1 < date2 ? <p style={{ color: '#F00', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                    date1 == date2 ? <p style={{ color: 'blue', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                        date1 > date2 ? <p style={{ color: '#008E00', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                            <p style={{ color: 'blue', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p>
            }
        </div>
    )
}
